import { create } from "zustand";
import { persist } from "zustand/middleware";

import { AppearanceStore } from "@/types";

export const appearanceStore = create<AppearanceStore>()(
  persist(
    (set) => ({
      isDarkMode: false,
      isWinterSidebar: true,
      setIsWinterSidebar: (isWinterSidebar) => {
        set({ isWinterSidebar });
      },
      toggleDarkMode: () => {
        set((state) => ({ isDarkMode: !state.isDarkMode }));
      },
    }),
    { name: "appearance" },
  ),
);
